import { ResourceUtils } from '../ResourceUtils';

export class FlowUtils {
  static typeName = 'flow';

  static getFolderId(flow) {
    return flow.folder ?? null;
  }

  static getOwnerUrisSetFromCards(flow) {
    const cardOwnerUris = new Set();

    if (flow.trigger != null) {
      const ownerUri = ResourceUtils.getOwnerUriFromId(flow.trigger);
      cardOwnerUris.add(ownerUri);
    }

    if (flow.conditions?.length) {
      for (const condition of flow.conditions) {
        const ownerUri = ResourceUtils.getOwnerUriFromId(condition);
        cardOwnerUris.add(ownerUri);
      }
    }

    if (flow.actions?.length) {
      for (const action of flow.actions) {
        const ownerUri = ResourceUtils.getOwnerUriFromId(action);
        cardOwnerUris.add(ownerUri);
      }
    }

    return cardOwnerUris;
  }
}
